module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-5.8700c752.jpg";